// extracted by mini-css-extract-plugin
export var carousel = "FullWidthCarousel-module--carousel--87075";
export var carouselContainer = "FullWidthCarousel-module--carouselContainer--5f1ed";
export var carouselItem = "FullWidthCarousel-module--carouselItem--3a028";
export var item = "FullWidthCarousel-module--item--c959e";
export var item__arrowUpRight = "FullWidthCarousel-module--item__arrowUpRight--5c881";
export var item__desc = "FullWidthCarousel-module--item__desc--ae800";
export var item__desc___active = "FullWidthCarousel-module--item__desc___active--db200";
export var item__footer = "FullWidthCarousel-module--item__footer--1e315";
export var item__image = "FullWidthCarousel-module--item__image--86de7";
export var item__subtitle = "FullWidthCarousel-module--item__subtitle--a907f";
export var item__tag = "FullWidthCarousel-module--item__tag--008e6";
export var item__title = "FullWidthCarousel-module--item__title--12c0c";
export var item__titleWrapper = "FullWidthCarousel-module--item__titleWrapper--06944";
export var singleItemContainer = "FullWidthCarousel-module--singleItemContainer--8d61d";